import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPurchaseOrder = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Purchase Order',
    body
  );
  return data;
});
export const updatePurchaseOrder = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Purchase Order/${id}`,
    body
  );
  return data;
});

export const getPurchaseOrder = catchAsync(async ({ key = '', value = '' }) => {
  let baseUrl =
    '/api/resource/Purchase Order?fields=["name","supplier_name","schedule_date","grand_total","status","total","docstatus"]&order_by=name desc&limit_start=0&limit_page_length=0';
  if (value) {
    if (key === 'schedule_date') {
      baseUrl += `&filters=[["schedule_date","Between",["${value}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
    }
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const deletePurchaseOrder = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Purchase Order/${record}`
  );
  return data;
});
export const getPurchaseOrderDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Purchase Order/${id}`
  );
  return data;
});
export const getMakePurchaseOrder = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=Make Purchase Order&source=${id}`
  );
  return data;
});
export const getOrderItemDetails = catchAsync(
  async (type, itemName, priceList) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_item_details?type=${type}&item=${itemName}&price_list=${priceList}`
    );
    return data;
  }
);
export const getVATDetails = catchAsync(async (type, name) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_tax_details?type=${type}&name=${name}`
  );
  return data;
});
